import styled from "styled-components";

export const RowDataWrapper = styled.div`
  padding: 24px;
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
  gap: 12px;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;
